import { getEnv, Instance, SnapshotOut, types } from 'mobx-state-tree'

import * as Storage from '../../utils/storage'
import { withRootStore } from '../extensions'
import { RootStoreEnv } from '../RootStoreEnv'

export const ENV_STORAGE_KEY = 'ENV_STORAGE_KEY'
export const ENV_PATH_PREFIX = 'ENV_PATH_PREFIX'

export enum EnvironmentStages {
  local = 'local',
  dev = 'dev',
  prod = 'prod',
  test = 'test'
}

/**
 * A EnvironmentStore model.
 */

export const EnvironmentStore = types
  .model('EnvironmentStore')
  .props({
    // Use EXPO_PUBLIC_STAGE (set in CI/.env/.xcode.env); process.env.STAGE is not set there so would default to dev
    stage: types.optional(
      types.enumeration<EnvironmentStages>('EnvironmentStages', Object.values(EnvironmentStages)),
      EnvironmentStages[process.env.EXPO_PUBLIC_STAGE as keyof typeof EnvironmentStages] || EnvironmentStages.dev
    ),
    pathPrefix: types.optional(types.string, ''),
    // Optional Convex deployment override, e.g. "agreeable-viper-813"
    convexDeployment: types.optional(types.string, '')
  })
  .extend(withRootStore)
  .views((self) => ({
    getEnv(): RootStoreEnv {
      return getEnv<RootStoreEnv>(self)
    },
    get isLocal() {
      return self.stage === EnvironmentStages.local
    },
    isDev() {
      return self.stage === EnvironmentStages.dev
    },
    isProd() {
      return self.stage === EnvironmentStages.prod
    }
  }))
  .actions((self) => ({
    async setStage(stage: EnvironmentStages) {
      self.stage = stage
      await Storage.save(ENV_STORAGE_KEY, stage)
      await self.rootStore.analytics.setAnalyticsStage(stage)
    },
    async setPathPrefix(pathPrefix: string) {
      self.pathPrefix = pathPrefix
      await Storage.save(ENV_PATH_PREFIX, pathPrefix)
    },
    setConvexDeployment(convexDeployment: string) {
      self.convexDeployment = convexDeployment
    }
  }))
  .actions((self) => {
    const afterCreate = async () => {
      // const env = getEnv<RootStoreEnv>(self)
      if (!self.stage) {
        const EnvStage = process.env.EXPO_PUBLIC_STAGE
        self.stage = EnvironmentStages[EnvStage as keyof typeof EnvironmentStages] || EnvironmentStages.dev
      }
    }

    const beforeDestroy = () => {
      return
    }

    return { afterCreate, beforeDestroy }
  })

/**
 * The EnvironmentStore instance.
 */
export type EnvironmentStoreType = Instance<typeof EnvironmentStore>

/**
 * The data of a EnvironmentStore.
 */
export type EnvironmentStoreSnapshot = SnapshotOut<typeof EnvironmentStore>
